'use client';
import './theme.css';
import type { PropsWithChildren } from 'react';

export function SaigonUIThemeProvider({ children }: PropsWithChildren) {
  return <div className="saigon-ui-root">{children}</div>;
}
